import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {MenuItemRendererProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/menus/MainMenu';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./MenuItemRenderer.less');
const cx = classnames.bind(styles);

@observer
export class MenuItemRenderer extends React.Component<MenuItemRendererProps, any>
{
    @bind
    private _onClick()
    {
        const {handler, menuItem} = this.props;
        if( handler )
            handler(menuItem);
    }

    render()
    {
        const {className, menuItem} = this.props;
        const isEnabled = menuItem.isEnabled;

        return <Row className={cx('menuItem', {'disabledMenuItem': !isEnabled}, className)}
                    onClick={isEnabled ? this._onClick : null}>
            {menuItem.title}
        </Row>;
    }
}
